import { SystemStyleObject } from '@chakra-ui/react';

export const PFTableStyle: SystemStyleObject = {
  borderCollapse: 'separate',
  borderSpacing: '0 16px',
  '& > tbody > tr > td': {
    h: '64px',
    boxSizing: 'border-box',
    fontWeight: 400,
    borderY: '1px solid',
    borderColor: 'palette_gray.10',
    paddingY: 'space_unit.x1',
    paddingX: 'space_unit.x2'
  },
  '& > thead > tr > th': {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: 'palette_gray.60',
    paddingY: 'space_unit.x1',
    paddingX: 'space_unit.x2'
  },
  '& > tbody > tr > td:first-of-type': {
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'palette_gray.10',
    borderLeftRadius: 'radii.x2'
  },
  '& > tbody > tr > td:last-of-type': {
    borderRightWidth: '1px',
    borderRightColor: 'palette_gray.10',
    borderRightRadius: 'radii.x2'
  }
};

export const newPFTableStyle: SystemStyleObject = {
  borderCollapse: 'separate',
  borderSpacing: '0 8px',
  '& > tbody > tr > td': {
    h: '56px',
    boxSizing: 'border-box',
    fontWeight: 400,
    paddingY: 'space_unit.x1',
    paddingX: 'space_unit.x2'
  },

  '& > thead > tr > th': {
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: 'palette_gray.60',
    paddingY: 'space_unit.x1',
    paddingX: 'space_unit.x2',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'palette_gray.5'
  },

  '& > thead > tr > th:first-of-type': {
    width: '350px'
  },

  '& > tbody > tr > td:first-of-type': {
    borderLeftRadius: 'radii.x2'
  },
  '& > tbody > tr > td:last-of-type': {
    borderRightRadius: 'radii.x2'
  }
};
